module.exports = __webpack_public_path__ + "static/media/headerlogo.4fa6374d.png";